import React, { useEffect } from 'react';
import { useNetworkStatus } from '@/shared/hooks/useNetworkStatus';
import { initChunkErrorHandler } from '@/shared/lib/chunkErrorHandler';

interface AppWrapperProps {
  children: React.ReactNode;
}

export const AppWrapper: React.FC<AppWrapperProps> = ({ children }) => {
  const networkStatus = useNetworkStatus();

  useEffect(() => {
    // Inicializa Application Insights primeiro para evitar race condition
    import('@/shared/lib/appInsights').then(({ initAppInsights }) => {
      initAppInsights();
      // Depois carrega o error handler que pode gerar eventos imediatamente
      return import('@/shared/lib/error-handler');
    });

    // Detecta erros de chunk dinâmico e recarrega silenciosamente
    initChunkErrorHandler();
  }, []);

  useEffect(() => {
    document.body.classList.toggle('offline', !networkStatus.isOnline);
    document.body.classList.toggle('slow-connection', networkStatus.isSlowConnection);
  }, [networkStatus.isOnline, networkStatus.isSlowConnection]);

  return <>{children}</>;
};